export default "__VITE_ASSET__b62c91d2__"